import * as React from 'react';
import { IColumn } from '../..';
import { IContextMenu } from '../../models/IContextMenu';
import styles from '../TVoSimpleGrid.module.scss';
import { ReactComponent as Check } from '../../assets/check.svg';
import { SortType } from '../../types/SortType';
import { contextMenuConfig } from '../../config';

export interface IContextMenuItemProps {
  contextMenu: IContextMenu;
  column: IColumn;
  onSorting: any;
  onGrouping: any;
  onContextMenuClick: any;
  dataSourceName: string;
  onContextMenuRender: any;
  sortDirection: SortType;
  isGrouping: boolean;
}

export default class ContextMenuItem extends React.Component<IContextMenuItemProps> {
  constructor(props: IContextMenuItemProps) {
    super(props);
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.contextMenu.value === contextMenuConfig.sortUp ||
        this.props.contextMenu.value === contextMenuConfig.sortDown ? (
          <li
            className={
              this.props.contextMenu.enableBottomDivider
                ? styles.bottomDivider
                : ''
            }
            onClick={this.props.onSorting.bind(
              this,
              this.props.column.key,
              this.props.column.fieldName,
              this.props.contextMenu.value
            )}
          >
            <div className={styles.menuItemWrapper}>
              {this.props.contextMenu.value === contextMenuConfig.sortUp &&
                this.props.sortDirection === SortType.up && <Check />}
              {this.props.contextMenu.value === contextMenuConfig.sortDown &&
                this.props.sortDirection === SortType.down && <Check />}
              <div className={styles.menuItemLabel}>
                <span>{this.props.contextMenu.label}</span>
              </div>
            </div>
          </li>
        ) : this.props.contextMenu.value === contextMenuConfig.groupBy ? (
          <li
            className={
              this.props.contextMenu.enableBottomDivider
                ? styles.bottomDivider
                : ''
            }
            onClick={this.props.onGrouping.bind(
              this,
              this.props.column.key,
              this.props.column.fieldName,
              !this.props.isGrouping
            )}
          >
            <div className={styles.menuItemWrapper}>
              {this.props.isGrouping && <Check />}
              <div className={styles.menuItemLabel}>
                <span>{this.props.contextMenu.label}</span>
              </div>
            </div>
          </li>
        ) : (
          <li
            className={
              this.props.contextMenu.enableBottomDivider
                ? styles.bottomDivider
                : ''
            }
            onClick={this.props.onContextMenuClick.bind(
              this,
              this.props.dataSourceName,
              this.props.column,
              this.props.contextMenu.value,
              this.props.contextMenu.label
            )}
          >
            <div className={styles.menuItemWrapper}>
              {this.props.contextMenu.enableOnContextMenuRender &&
              this.props.onContextMenuRender !== undefined ? (
                this.props.onContextMenuRender(
                  this.props.dataSourceName,
                  this.props.column.key,
                  this.props.column.fieldName,
                  this.props.contextMenu.value,
                  this.props.contextMenu.label
                )
              ) : (
                <div className={styles.menuItemLabel}>
                  <span>{this.props.contextMenu.label}</span>
                </div>
              )}
            </div>
          </li>
        )}
      </React.Fragment>
    );
  }
}
